<div class="flex justify-between items-center" [ngClass]="blockClass" (click)="openTransaction()" role="button">
    <div class="flex flex-col gap-3">
        <p class="mb-0" [ngClass]="{'!hidden': !show.includes('label') || !isLabel}">
            <span class="entity-badge text-12-400 color-7">{{ ss.t('common_moneyTracker') }}</span>
        </p>

        <div class="flex flex-col gap-2">
            <div class="flex items-center">
                <app-me-user-avatar [uid]="transaction().uid || ''" size="small" class="ri-me-2"
                    *ngIf="transaction().uid && transaction().uid !== cc.user.uid"></app-me-user-avatar>
                <p class="text-16-400 color-8 mb-0">{{ schedule()?.title || transaction().title || entry.sortTitle }}
                </p>
            </div>
            <p class="text-12-400 color-7 mb-0"
                [ngClass]="{'!hidden': descriptionType === 'none' || !transaction().description}">{{
                (transaction().description || '') | parseText: descriptionType === 'short' ? 'short' : 'full' }}</p>
        </div>
        <div class="flex gap-3 flex-wrap"
            [ngClass]="{'!hidden': (!show.includes('attachments') || attachments().length === 0) && (!show.includes('time') || !schedule()?.startTime) && (!show.includes('reminder') || !schedule()?.reminderAt?.length) && (!show.includes('repeat') || !schedule()?.repeat) && !show.includes('setup') && !isSetup && collabCount() === 0 && (!show.includes('access') || role() === 'owner')}">
            <div class="inline-flex items-center gap-1.5"
                *ngIf="show.includes('attachments') && attachments().length > 0">
                <app-svg name="attachment" [color]="ss.theme().color7" width="12" height="12"></app-svg>
                <span class="text-12-400 color-7">{{ attachments().length > 10 ? '10+' : attachments().length }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5"
                [ngClass]="{'!hidden': !show.includes('collaboratorsCount') || collabCount() === 0 }">
                <app-svg name="users" [color]="ss.theme().color7" width="14" height="14"></app-svg>
                <span class="text-12-400 color-7">{{ collabCount() > 10 ? '10+' : collabCount() }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5"
                [ngClass]="{'!hidden': !show.includes('access') || role() === 'owner'}">
                <app-svg [name]="role() === 'editor' ? 'edit' : 'view'" [color]="ss.theme().color7" width="12"
                    height="12"></app-svg>
                <span class="text-12-400 color-7">{{ roleMap()[role() || 'viewer'] }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5" *ngIf="show.includes('time') && schedule()?.startTime">
                <app-svg name="clock" [color]="ss.theme().color7" width="12" height="12"></app-svg>
                <span class="text-12-400 color-7">{{ schedule()?.startTime | parseTimeLocal }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5"
                *ngIf="show.includes('reminder') && schedule()?.reminderAt?.length && schedule()?.startTime">
                <app-svg name="bell" [color]="ss.theme().color7" width="12" height="12"></app-svg>
                <span class="text-12-400 color-7"><span *ngFor="let r of schedule()!.reminderAt!; let i = index">{{
                        ds.getReminderText(r) }}<span *ngIf="i < schedule()!.reminderAt!.length - 1">,
                        </span></span></span>
            </div>
            <div class="inline-flex items-center gap-1.5" *ngIf="show.includes('repeat') && schedule()?.repeat">
                <app-svg name="repeat" [color]="ss.theme().color7" class="icon-mirror-rtl" width="12"
                    height="12"></app-svg>
                <span class="text-12-400 color-7">{{ schedule()!.repeat! | parseRule }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5" *ngIf="show.includes('setup') && setup()">
                <app-svg name="widget" [color]="ss.theme().color7" width="12" height="12"></app-svg>
                <span class="text-12-400 color-7">{{ setup().title }}</span>
            </div>
        </div>
        <p class="text-12-400 color-7 mb-0 hashtags-block"
            [ngClass]="{'!hidden': !show.includes('hashtag') || ss.getValidHashtags(transaction().tags || []).length === 0 || role() !== 'owner'}">
            <span class="hashtag"
                *ngFor="let tagId of ss.getValidHashtags(transaction().tags || [])">#{{ss.tagMap()[tagId]}}</span>
        </p>
    </div>
    @if (transaction().amount) {

    <p class="text-16-400 mb-0 whitespace-nowrap ri-ps-4" *ngIf="transaction().amount"
        [ngClass]="transaction().transactionType === 'income' ? 'color-35' : 'color-11'">{{ transaction().amount |
        parseMoney: (setup().currencyCode || 'USD') : ss.appLanguageCode() }}</p>
    } @else {
    <p class="text-18-400 emptymoney mb-0 whitespace-nowrap ri-ps-4"
        [ngClass]="transaction().transactionType === 'income' ? 'color-35' : 'color-11'">--</p>
    }
</div>